(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('MessageHistoryCtrl', ['$scope', '$stateParams', 'messageHistoryService', '$q', '$timeout', 'profileHelper', 'sharedDataService', 'moment', '$uibModal', 'permissionService', 'channelsProvider', function ($scope, $stateParams, messageHistoryService, $q, $timeout, profileHelper, sharedDataService, moment, $uibModal, permissionService, channelsProvider) {
            $scope.profileData = profileHelper.getProfile();
            var availableChannels = profileHelper.getAvailableChannels();
            $scope.allAvailableChannels = Object.keys(availableChannels).reduce((obj, key) => {
                if(!channelsProvider[key] || channelsProvider[key].allowed){
                    obj[key] = availableChannels[key]
                }
                return obj;
            }, {});
            $scope.availableChannels = [];
            var translatedChannels = {};
            $scope.pickedChannels = [];
            var approvedPickedChannels = [];
            
            $scope.devPermission = permissionService.checkPermission("msg:r");

            $scope.checkIfDisplay = function (channelId) {
                return channelId ? approvedPickedChannels.includes(translatedChannels[channelId]) : true;
            };

            function changeChannels() {
                $scope.availableChannels = [];
                $scope.availableChannels = [];
                translatedChannels[channel] = [];
                for (var channel in $scope.allAvailableChannels) {
                    $scope.pickedChannels.push($scope.allAvailableChannels[channel].label);
                    $scope.availableChannels.push($scope.allAvailableChannels[channel].label);
                    translatedChannels[channel] = $scope.allAvailableChannels[channel].label;
                }
                approvedPickedChannels = angular.copy($scope.pickedChannels);
            }

            changeChannels();

            $scope.$watch('allAvailableChannels', changeChannels, true);

            $scope.$watch('pickedChannels', function(){
                approvedPickedChannels = angular.copy($scope.pickedChannels);
            }, true);

            var lastFrom = new Date();
            
            $scope.calendar = {
                from: {
                    date: lastFrom
                },
                to: {

                }
            };

            $scope.open = function ($event, toOpen) {
                $event.preventDefault();
                $event.stopPropagation();
                toOpen.opened = true;
            };

            var _selectedDateRange = null;
            Object.defineProperty($scope, 'selectedDateRange', {
                get: function () {
                    return _selectedDateRange;
                },
                set: function (date) {
                    _selectedDateRange = date;
                    switch (date) {
                        case "Today":
                            $scope.calendar.to.date = moment().startOf('day').toDate();
                            $scope.calendar.from.date = moment().toDate();
                            break;
                        case "7Days":
                            $scope.calendar.to.date = moment().startOf('week').toDate();
                            $scope.calendar.from.date = moment().toDate();
                            break;
                        case "30Days":
                            $scope.calendar.to.date = moment().startOf('month').toDate();
                            $scope.calendar.from.date = moment().toDate();
                            break;
                        case "clear":
                            $scope.calendar.from.date = new Date();
                            $scope.calendar.to.date = null;
                            break;
                    }
                }
            });

        }]).controller('messageDetails', ['$scope', '$timeout', '$uibModalInstance', 'message', function ($scope, $timeout, $uibModalInstance, message) {
            
            $timeout(function () {
                var cm = angular.element(document.querySelector('.CodeMirror'));
                cm[0].CodeMirror.refresh();
            }, 0);

            $scope.message = message;

            $scope.editorOptions = {
                lineWrapping: true,
                lineNumbers: true,
                autofocus: true,
                theme: "panda-syntax",
                mode: "application/json"
            };
            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
    }]);

})(window.angular);